import { useState,useRef,useEffect } from "react";
import {Label} from '../../components/fieldsComp';
import {settingservices} from '../../services/settingServices';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';

const PermissionSubscription = () =>{

    const toast = useRef(null); 
    const [initialvalue,setvalues] = useState({
        'isactive':'active'
    });

    const [subscriptionsperm,setSubscription] = useState([]);
    
    useEffect(()=>{
       getsubscriptionperm();  
       displaysubscriptionsperm(); 
    },[])
    
    const handleChanges = (e) =>{
         setvalues((prevData)=>{
             return {
                 ...prevData,
                 [e.target.name]:e.target.value
             } 
         });   
    }

    const addsubscriptionperm = (e) =>{
        e.preventDefault();
        // console.log("add subscriiption"); 
        // console.log(initialvalue);
        settingservices.addsubscriptionperm(initialvalue).then((response)=>{
             if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Subscription', detail: 'Added successfully' });
                getsubscriptionperm();
             }else{
                toast.current.show({ severity: 'error', summary: 'Subscription', detail: 'Not added' }); 
             }
        }).catch((error)=>{
             console.log(error);
        })
    }


    const getsubscriptionperm = () =>{
        settingservices.getsubscriptionpperm().then((response)=>{
             if(response.status == 200){
                setSubscription(response.data.data);
             }else{
                setSubscription([]);
             }
        }).catch((error)=>{
             setSubscription([]);
             console.log(error);
        })
    }


    const displaysubscriptionsperm = () =>{
         let tempdata = [];
         subscriptionsperm.forEach((value)=>{
            // console.log(value);
            tempdata.push(
            <tr>
            <td>{value.id}</td>
            <td>{value.name}</td>
            <td><Tag severity={value.isactive == 'active' ? "success" : "error"}  value={value.isactive} rounded></Tag></td>
            <td>
            <button className="btn btn-white-custom btn-sm"><i className="icon icon-note icon-style"></i></button>
                 &nbsp;
                 <button className="btn btn-white-custom btn-sm"><i className="icon icon-trash txt-error icon-style"></i></button></td>
            
            </tr>);  
         })

         return tempdata;

    }
   return (
    <>
       <Toast ref={toast} /> 
           <div className="card">
            <div className="card-body">
           <form onSubmit={(e)=>addsubscriptionperm(e)}>
            <div class="row">
                <div className="col-md-3"> 
                 <div class="form-group">
                    {/* <label for="name"><i className="fa fa-star" style={{fontSize:'10px',color:'red'}}></i> <b>Name</b></label> */}
                    <Label name={'Name'}/>
                    <input
                        type="text"
                        class="form-control"
                        id="name"
                        name="name"
                        required
                        placeholder="Enter permission name"
                        onChange={handleChanges}
                    />
                 </div>
                </div>
                
                <div className="col-md-2"> 
                    <div class="form-group">
                        <Label name={'Isactive'}/> 
                        {/* <label for="email2">Isactive</label>       */}
                        <select name="isactive" onChange={handleChanges} required className="form-control">
                            <option value="active">Active</option>
                            <option value="inactive">InActive</option>
                        </select>
                    </div>
                </div>

                <div className="col-md-3">
                   <div class="form-group">
                       <br/>
                      <button className="btn btn-success-custom" type="submit">Save</button>
                   </div>
                  
                </div>
                
             </div>
             </form>
             </div>

             <div className="row">
                 <div className="col-md-12">
                 <div class="card">
                  <div class="card-header">
                    <h4 class="h5">Permissions</h4>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive">
                      <table
                        id="multi-filter-select"
                        class="display table table-striped table-hover"
                      >
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Isactive</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        {/* <tfoot>
                          <tr>
                            <th>Name</th>
                            <th>Position</th>
                            <th>Office</th>
                            <th>Age</th>
                            <th>Start date</th>
                            <th>Salary</th>
                          </tr>
                        </tfoot> */}
                        <tbody>
                            {displaysubscriptionsperm()}
                          {/* <tr>
                            <td>Tiger Nixon</td>
                            <td>System Architect</td>
                            <td>Edinburgh</td>
                            <td>61</td>
                            <td>2011/04/25</td>
                            <td>$320,800</td>
                          </tr> */}
                          {/* <tr>
                            <td>Garrett Winters</td>
                            <td>Accountant</td>
                            <td>Tokyo</td>
                            <td>63</td>
                            <td>2011/07/25</td>
                            <td>$170,750</td>
                          </tr> */}
                          {/* <tr>
                            <td>Ashton Cox</td>
                            <td>Junior Technical Author</td>
                            <td>San Francisco</td>
                            <td>66</td>
                            <td>2009/01/12</td>
                            <td>$86,000</td>
                          </tr> */}
                         
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div> 
                
                </div>   
             </div>
             </div>  
    
    </>
   );       
}

export default PermissionSubscription;